export default __webpack_public_path__ + "static/media/treenvest.2d715823.png";